<lgv-dialog-wrapper [titleText]="data.title" (closed)="onCancelClicked()">
  <mat-radio-group class="radio-group" [(ngModel)]="selectedOption">
    @for (option of options; track option) {
      <mat-radio-button
        color="primary"
        class="radio-button"
        [value]="option.key"
        [disabled]="
          (data.isFromDragDropAndOtherDay && option.key !== 'one') ||
          (data.tm.interval > 1 && data.tm.frequencyType === 'daily' && option.key === 'until')
        "
      >
        <div translate>{{ option.value }}</div>
      </mat-radio-button>
    }
  </mat-radio-group>

  @if (selectedOption === 'until') {
    <mat-form-field (click)="dp.open()" appearance="fill">
      <mat-label translate>dashboard_dialogs_editdeleterecurring_until_date</mat-label>
      <input
        matInput
        [matDatepickerFilter]="myFilter"
        [matDatepicker]="dp"
        [(ngModel)]="untilDate"
        [min]="data.splitUntilMinDate"
      />
      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
      <mat-datepicker [dateClass]="dateClass" #dp></mat-datepicker>
    </mat-form-field>
  }

  @if (untilDateError) {
    <mat-error translate>dashboard_dialogs_editdeleterecurring_until_date_error</mat-error>
  }

  <lgv-button-container
    buttonLeftText="dashboard_dialogs_editdeleterecurring_buttonleft"
    buttonRightText="dashboard_dialogs_editdeleterecurring_buttonright"
    (onLeftClicked)="onCancelClicked()"
    (onRightClicked)="onOkClicked()"
  >
  </lgv-button-container>
</lgv-dialog-wrapper>
